import { Project } from "./types/general"

export const linkedinProfile = "https://www.linkedin.com/in/khrystyna-quirino"
export const githubProfile = "https://github.com/krys-s21"

export const projects: Project[] = [
  {
    id: 1,
    name: "My Mist",
    image: "/images/projects/my_mist.png",
    shortDescription:
      "Rethinking e-commerce with a flexible, mix & match experience driven by users.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 2,
    name: "La Piadina",
    image: "/images/projects/la_piadina.png",
    shortDescription:
      "Bold visuals, big typography, and playful transitions — La Piadina’s site still serves up the same charm years later.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 3,
    name: "Free Society",
    image: "/images/projects/free_society.png",
    shortDescription:
      "A clean, elegant e-commerce experience—rooted in timeless design principles.",
    description: "",
    showMore: false,
    images: [],
  },
  // {
  //   id: 4,
  //   name: "Airport game",
  //   image: "",
  //   shortDescription: "",
  //   description: "",
  // },
  {
    id: 5,
    name: "Heden",
    image: "/images/projects/heden.png",
    shortDescription:
      "As a freelancer, I crafted this appealing, clean UI with CMS settings for seamless content management.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 6,
    name: "YMC",
    image: "/images/projects/YMC2.png",
    shortDescription:
      "Genuinely in love with the outcome of this full UI implementation, adding section animations for a pleasant UX.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 7,
    name: "Hermes Protocol",
    image: "/images/projects/hermes.png",
    shortDescription:
      "At Momentum One, I led project implementation, influencing design and UX decisions. Exciting journey!",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 8,
    name: "Iris by Unlockit",
    image: "/images/projects/unlockit.png",
    shortDescription:
      "From zero to launch — co-designed and developed Iris with a collaborative, agile, cross-functional team.",
    description: "",
    showMore: false,
    images: [],
  },
]
export const highlightedProjects: Project[] = [
  {
    id: 5,
    name: "YMC",
    image: "/images/projects/YMC2.png",
    shortDescription:
      "Genuinely in love with the outcome of this full UI implementation, adding section animations for a pleasant UX.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 8,
    name: "Iris by Unlockit",
    image: "/images/projects/unlockit.png",
    shortDescription:
      "From zero to launch — co-designed and developed Iris with a collaborative, agile, cross-functional team.",
    description: "",
    showMore: false,
    images: [],
  },
  {
    id: 6,
    name: "Heden",
    image: "/images/projects/heden.png",
    shortDescription:
      "As a freelancer, I crafted this appealing, clean UI with CMS settings for seamless content management.",
    description: "",
    showMore: false,
    images: [],
  },
]
